import { Skeleton } from 'antd';
import { NftAvatarBlockSkeleton } from 'components/Shared/NftAvatarBlock/Skeleton';
import { NftBlockchainSkeleton } from 'components/Shared/NftBlockchain/Skeleton';
import { NftDescriptionSkeleton } from 'components/Shared/NftDescription/Skeleton';
import { NftPropertiesSkeleton } from 'components/Shared/NftProperties/Skeleton';
import * as Styled from './styles';
import { isMobile } from 'utils';

export const NftDetailsPlainSkeleton = () => {
  return (
    <Styled.NftDetailsPlainWrapper>
      {isMobile() && <NftDescriptionSkeleton showLabel />}
      <Styled.NftCreatorSection>
        <NftAvatarBlockSkeleton size="large" />
      </Styled.NftCreatorSection>
      <Styled.NftDetailsPlainSection>
        <Skeleton.Button
          active
          block
          style={{
            height: 24,
            width: '50%',
            margin: '40px 0 0 0'
          }}
        />
        <Skeleton.Button
          active
          block
          style={{
            height: 24,
            width: '40%',
            margin: '20px 0 16px 0'
          }}
        />
        <NftPropertiesSkeleton />
      </Styled.NftDetailsPlainSection>
      <Styled.NftDetailsPlainSection>
        <Styled.NftDetailsPlainSectionTitle>
          <Skeleton.Button
            active
            block
            style={{
              height: 24,
              width: '40%',
              margin: '20px 0 16px 0'
            }}
          />
        </Styled.NftDetailsPlainSectionTitle>
        <NftBlockchainSkeleton />
      </Styled.NftDetailsPlainSection>
    </Styled.NftDetailsPlainWrapper>
  );
};
